// extracted by mini-css-extract-plugin
export default {"heading":"CommoditiesTemplate_heading__gjHAI"};